import _component from './component';
import _error from './error';
import _numbers from './numbers';
import _platform from './platform';
import _throttle from './throttle';

export const component = _component;
export const error = _error;
export const numbers = _numbers;
export const platform = _platform;
export const throttle = _throttle;

export default {
  component,
  error,
  numbers,
  platform,
  throttle
};
